import {fetchGET, fetchPOST} from "./fetch";
import {useMyMutation} from "./mymutation";
import {useQuery} from "@tanstack/react-query";

const REACT_QUERY_ID_SEXES = "sexes";
const BASE_URL = "/api/sexes";

const sexesQueryConfig = {
    staleTime: 0,
    cacheTime: 1000 * 60 * 5,
}

export function useSexes() {
    const result = useQuery({
        queryKey: [REACT_QUERY_ID_SEXES],
        queryFn: async () => await fetchGET(BASE_URL),
        //onError: e => setError(e),
        ...sexesQueryConfig
    });
    return {...result, sexes: result.data};
}

export const PROVINCE_EMPTY = {file:""};

export function useFileMutations() {

    async function uploadFileFunction(file){
        return await fetchPOST(`${BASE_URL}`,file,true)
    }
    return {
        uploadFile:useMyMutation(uploadFileFunction,REACT_QUERY_ID_SEXES, file => `file ${file.title} created`),
    };

}